import {
  LANGUAGE_ENGLISH,
  LANGUAGE_ENGLISH_MURABAHA,
  LOCALE_ENGLISH_US,
} from '../constants';
import calculatorsAmortizeMessages from '../../redux/Calculators/Amortize/messages';
import calculatorsMessages from '../../redux/Calculators/messages';
import changeEmailMessages from '../../redux/Register/ChangeEmail/messages';
import documentsMessages from '../../redux/Documents/messages';
import forgotUsernameMessages from '../../redux/Register/ForgotUsername/messages';
import forgotPasswordMessages from '../../redux/Register/ForgotPassword/messages';
import footerMessages from './footerMessages';
import helmetMessages from './helmetMessages';
import helpMessages from '../../redux/Help/messages';
import loginMessages from '../../redux/Login/messages';
import lossDraftMessages from '../../redux/LossDraft/messages';
import mainMessages from '../../redux/Main/messages';
import mortgageMessages from '../../redux/Mortgage/messages';
import navigationMessages from './navigationMessages';
import notificationsMessages from '../../redux/Notifications/messages';
import paymentsAutopayMessages from '../../redux/Payments/Autopay/messages';
import paymentsFlexdraftMessages from '../../redux/Payments/FlexDraft/messages';
import paymentsHistoryMessages from '../../redux/Payments/History/messages';
import paymentsMessages from '../../redux/Payments/messages';
import paymentsOneTimePaymentMessages from '../../redux/Payments/OneTimePayment/messages';
import payoffMessages from '../../redux/Payoff/messages';
import registerMessages from '../../redux/Register/Main/messages';
import secureMessagingMessages from '../../redux/SecureMessaging/messages';
import settingsCommuncationsMessages from '../../redux/Settings/Communications/messages';
import settingsLoansMessages from '../../redux/Settings/Loans/messages';
import setttingsProfileMessages from '../../redux/Settings/Profile/messages';
import sitemapMessages from './sitemapMessages';

const languageDictionary = {
  [LANGUAGE_ENGLISH]: {
    locale: LOCALE_ENGLISH_US,
    messages: {
      ...calculatorsAmortizeMessages[LANGUAGE_ENGLISH],
      ...calculatorsMessages[LANGUAGE_ENGLISH],
      ...changeEmailMessages[LANGUAGE_ENGLISH],
      ...documentsMessages[LANGUAGE_ENGLISH],
      ...footerMessages[LANGUAGE_ENGLISH],
      ...forgotPasswordMessages[LANGUAGE_ENGLISH],
      ...forgotUsernameMessages[LANGUAGE_ENGLISH],
      ...helmetMessages[LANGUAGE_ENGLISH],
      ...helpMessages[LANGUAGE_ENGLISH],
      ...loginMessages[LANGUAGE_ENGLISH],
      ...lossDraftMessages[LANGUAGE_ENGLISH],
      ...mainMessages[LANGUAGE_ENGLISH],
      ...mortgageMessages[LANGUAGE_ENGLISH],
      ...navigationMessages[LANGUAGE_ENGLISH],
      ...notificationsMessages[LANGUAGE_ENGLISH],
      ...paymentsAutopayMessages[LANGUAGE_ENGLISH],
      ...paymentsFlexdraftMessages[LANGUAGE_ENGLISH],
      ...paymentsHistoryMessages[LANGUAGE_ENGLISH],
      ...paymentsMessages[LANGUAGE_ENGLISH],
      ...paymentsOneTimePaymentMessages[LANGUAGE_ENGLISH],
      ...payoffMessages[LANGUAGE_ENGLISH],
      ...registerMessages[LANGUAGE_ENGLISH],
      ...secureMessagingMessages[LANGUAGE_ENGLISH],
      ...settingsCommuncationsMessages[LANGUAGE_ENGLISH],
      ...settingsLoansMessages[LANGUAGE_ENGLISH],
      ...setttingsProfileMessages[LANGUAGE_ENGLISH],
      ...sitemapMessages[LANGUAGE_ENGLISH],
    },
  },
  [LANGUAGE_ENGLISH_MURABAHA]: {
    locale: LOCALE_ENGLISH_US,
    messages: {
      ...calculatorsAmortizeMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...calculatorsMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...changeEmailMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...documentsMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...footerMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...forgotPasswordMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...forgotUsernameMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...helmetMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...helpMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...loginMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...lossDraftMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...mainMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...mortgageMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...navigationMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...notificationsMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...paymentsAutopayMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...paymentsFlexdraftMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...paymentsHistoryMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...paymentsMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...paymentsOneTimePaymentMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...payoffMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...registerMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...secureMessagingMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...settingsCommuncationsMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...settingsLoansMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...setttingsProfileMessages[LANGUAGE_ENGLISH_MURABAHA],
      ...sitemapMessages[LANGUAGE_ENGLISH_MURABAHA],
    },
  },
};

export default languageDictionary;
